import BaseDevice from '../base.js'
export default class DeviceImage extends BaseDevice {

   static render = (device, scale = 1) => {
      return this.getDevice(device, scale, false, true);
   }

   static getTextPadding = (device, DEFAULT_PADDING) => {

      if (!device.height) {
         return DEFAULT_PADDING;
      }
      return DEFAULT_PADDING * device.height / 100
   }


   // static getHeight = (device) => {
   //    console.log(">???????", device.height);

   //    if (!device.height) {
   //       return SIZE.baseHeight
   //    }

   //    return SIZE.baseHeight * device.height / 100
   // }
}
